module.exports = __webpack_public_path__ + "static/media/flow-popup-menu.879958d2.png";